// Checkbox input field component
let filters = {
    props: {
        groupeFiltres: Object,
        filtre: Object
    },
    methods: {
        filtrevent() {
            this.$root.callfilters(event)
        },
        clicklabel() {
            this.$emit('changed')
        }
    },
    template: `
    <li :class="filtre.selected ? 'filter selected' : 'filter'" >
        <input @change="filtrevent" :checked="filtre.selected ? 'checked' : false" :rel="filtre.idFiltre" type="checkbox" :id="'filter' + filtre.idFiltre" :value="groupeFiltres.idGroupe" :name="'filter' + filtre.idFiltre" v-model="filtre.selected">
        <label @click="clicklabel" class="checkbox-label" :for="'filter' + filtre.idFiltre">{{ filtre.libFiltre }} ({{ filtre.countResultFiltre }}) <div v-if="!!filtre.selected"><i class="fad fa-times"></i></div></label>
    </li>
    `
};
